var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height d-flex flex-column"},[_c('profile-app-bar',{attrs:{"title":_vm.$route.meta.appBarTitle || _vm.$route.meta.documentTitle,"prev-page":_vm.prevPage,"show-drop-down":false}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }